import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "./model"
import { Creators as HookCreators } from "model/hookUpdater"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    resourceId: props.resourceId,
  }),
  mapStateToProps: (state) => ({
    ...get(state, "modules.tagAndAttributeCreator"),
  }),
  actions: {
    ...Creators,
    update: HookCreators.update,
  },
})
